import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import InlineLoader from 'components/common/loaders/InlineLoader';
import StyledButton from './styled';

const BaseButton = ({
  children,
  isLoading,
  onClick,
  className,
  disabled,
  size,
  icon,
  type,
  ...rest
}) => (
  <StyledButton
    {...rest}
    icon={icon}
    type={type}
    onClick={onClick}
    disabled={disabled}
    isLoading={isLoading}
    className={className}
  >
    {icon && <Icon name={icon} size={size} />}
    {children}
    {isLoading && <InlineLoader />}
  </StyledButton>
);

BaseButton.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.string
};
BaseButton.defaultProps = {
  children: '',
  size: 'large',
  className: '',
  disabled: false,
  icon: undefined,
  isLoading: false,
  onClick: () => {},
  type: 'button'
};

export default BaseButton;
